export default __webpack_public_path__ + "static/1332-2140c65b122f4abeba831f95b4d72573.gif";